import { AppService } from './AbstractService';

export default class BankService extends AppService {
  public async getAllBanks() {
    return this.makeRequest('GET', '/banks');
  }
}
